<script lang="ts">
</script>

<span class="separator"></span>

<style lang="scss">
  .separator {
    display: block;
    background: var(--grid-stroke);
    height: 1.5rem;
    width: 1px;
  }
</style>
